import styled from 'styled-components';
import { COLOR } from '../../../styles/variables';

export const TagLayout = styled.a`
    display: inline-block;
    font-size: 12px;
    font-family: Standard;
    font-weight: normal;
    text-decoration: none;
    line-height: 1.2;
    border-radius: 8px;
    padding: 0.5rem;
    margin: 0 1rem 0.5rem 0;
    color: black;
    background-color: ${COLOR.br24.lightGrey};

    :hover {
        color: ${COLOR.br24.blue};
    }
`;
